import { FlightFilters, FlightsResponse } from "./types";

const FLIGHTS_API_URL =
  process.env.REACT_APP_FLIGHTS_API_URL || "https://api.fleet.aerovect.com";

const BASE_URL =
  process.env.NODE_ENV === "production"
    ? `${FLIGHTS_API_URL}/flights`
    : "/api/flights";

export async function fetchFlights(
  filters: FlightFilters,
  token: string,
  signal?: AbortSignal,
): Promise<FlightsResponse> {
  const params = new URLSearchParams({
    airport: filters.airport,
    hours_back: String(filters.hoursBack),
    hours_forward: String(filters.hoursForward),
    mission_type: filters.missionType,
    require_bag_pier: String(filters.requireBagPier),
  });

  const response = await fetch(`${BASE_URL}?${params}`, {
    headers: { Authorization: `Bearer ${token}` },
    signal,
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(`API error ${response.status}: ${text}`);
  }

  return response.json();
}
